"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _InterestAccountsSettingContainer = _interopRequireDefault(require("./InterestAccountsSettingContainer"));
require("./TradeSettings.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var themeClasses = (0, _cssClassesHelper.getBEMClasses)('trade-settings');
var InterestSettings = function InterestSettings(_ref) {
  var getInterestAccountStatus = _ref.getInterestAccountStatus,
    selectedAccountId = _ref.selectedAccountId;
  var _useTranslation = (0, _reactI18next.useTranslation)("user"),
    t = _useTranslation.t;
  (0, _react.useEffect)(function () {
    getInterestAccountStatus();
    return function () {};
  }, [selectedAccountId]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('header')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('header-text')
  }, t("Adjust Yield Settings")), /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('description')
  }, t("Lorem ipsum dolor sit amet, consectetur adipiscing  elit."))), /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('settings')
  }, /*#__PURE__*/_react["default"].createElement(_InterestAccountsSettingContainer["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('row')
  })));
};
var _default = exports["default"] = InterestSettings;